import './style.scss';
import React from 'react';
import clsx from 'clsx';
import OfferCardGridItemComponent from '../OfferCardGridItemComponent';
import { withTranslation } from 'react-i18next';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const MostRecentOffersComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="MostRecentOffersComponent" />;
  }
  const { items: cards } = props?.fields;
  const shouldRenderCards = !!cards;

  const { t, params, i18n } = props;
  const lang = i18n.language;
  return (
    <div className={clsx('offer-card-grid-items flex-it flex-wrap', 'add-margins', params?.Styles)}>
      {shouldRenderCards &&
        cards?.map((card, iCard) => {
          return <OfferCardGridItemComponent item={card} key={iCard} lang={lang} translate={t} />;
        })}
    </div>
  );
};
export default withTranslation()(MostRecentOffersComponent);
